import { Icon, Typography, VStack } from '@vivaahealth/design-system';
import { useTranslation } from 'react-i18next';
import { camelCase } from 'lodash';

import Row from '../../../../components/Row';
import TextData from '../../../../components/TextData';

interface ContactProps {
  firstName: string | null;
  lastName: string | null;
  relationship: string | null;
  contactPhoneNumber: string;
  relative?: boolean;
}

const Contact = (props: ContactProps) => {
  const { t } = useTranslation('review');
  const {
    firstName,
    lastName,
    relationship,
    contactPhoneNumber,
    relative = false,
  } = props;
  return (
    <VStack gap={16}>
      <Typography bold variant="headline-small">
        {`${firstName} ${lastName}`}
      </Typography>
      <Row Icon={Icon.Phone}>
        {contactPhoneNumber && (
          <TextData
            label={t('emergencyContractPhoneNumberLabel')}
            value={contactPhoneNumber}
          />
        )}
        {relationship && (
          <TextData
            label={t(
              camelCase(
                relative
                  ? 'emergencyRelativeContactRelationshipLabel'
                  : 'emergencyContactRelationshipLabel',
              ),
            )}
            value={t(relationship)}
          />
        )}
      </Row>
    </VStack>
  );
};

export default Contact;
